import { useEffect } from "react";
import { AuthProvider } from "./context/auth/AuthContext";
import { AppRouter } from "./routers/AppRoutes";
import './assets/styles/default.css';
import './assets/styles/lafise.css';
import './assets/styles/global.css';
import './assets/styles/bncr.css';

const App = () => {
  
  useEffect(() => {
    const company = process.env.REACT_APP_COMPANY ;
    let companyStyle;

    switch (company) {
      
      case 'global':
        companyStyle = 'global'; 
        break;  
      case 'lafise':
        companyStyle ='lafise'; 
        break; 
        case 'bncr':
          companyStyle ='bncr'; 
          break;    
      default:
        companyStyle ='default'; 
        break; 
    }
    document.body.classList.add(companyStyle);

    return () => {
      document.body.classList.remove(companyStyle);
    };
  }, []);

  return(
  <AuthProvider>    
    <AppRouter/>
  </AuthProvider>
  
)

};


export default App;

